import axios from 'axios';

const API_URL = process.env.VUE_APP_API_BASE_URL + '/auth/';

class AuthService {
  login(user) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    }

    const user_params = new URLSearchParams(user).toString()

    return axios
      .post(API_URL + 'signin', user_params, {headers: headers})
      .then(response => {
        if (response.data.access_token) {
          localStorage.setItem('user', JSON.stringify(response.data));
          axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.access_token
        }
        return response.data
      })
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }

  verifyTOTP(data) {
    return axios
      .post(API_URL + 'totp_verify', data)
      .then(response => {
        if (response.data.access_token) {
            localStorage.setItem('user', JSON.stringify(response.data));
            axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.access_token
        }
        return response.data
      })
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }


  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();